require("!!/app/node_modules/script-loader/addScript.js")(require("!!/app/node_modules/raw-loader/index.js!/app/node_modules/handsontable/dist/handsontable.full.js"))


//////////////////
// WEBPACK FOOTER
// /app/~/script-loader!/app/~/handsontable/dist/handsontable.full.js
// module id = ../../../../script-loader/index.js!../../../../handsontable/dist/handsontable.full.js
// module chunks = 14